<template>
  <div id="additional-cost-calculator" :class="{modalCalculator:true,show:showModal}">
    <div class="modal-content additional-cost">

      <div class="container-fluid">
        <span class="close cursor" @click="closeModal">&times;</span>
        <div class="calculator-wrapper">
          <div class="row inner-wrapper">
            <div class="col-12 header">{{$store.getters.translations.service_charge_calculator}}</div>
              <div class="col-12">
                <div class="row selling-price">
                  <div class="col-8">{{$store.getters.translations.purchase_price}}</div>
                  <div class="col-2 calc-value">
                    {{sellingPrice}}
                    <span>€</span>
                  </div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div class="col-8">{{$store.getters.translations.land_transfer_tax}}
                    <div class="select-wrapper">
                      <select @change="changeRealEstateTransferTax" id="real-estate-traffic-tax-select" >
                        <option v-for="value in trafficTaxes" v-bind:key="value.value" :value="value.value">{{value.country}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-2 calc-value">
                    {{toLocalString(realEstateTransferTax)}}
                    <span>€</span>
                  </div>
                  <div class="col-2 input-style">
                    <input v-bind:value="realEstateTransferTaxFactor" class="percent-value"
                           @change="changeRealEstateTransferTaxFactor" type="text" id="realEstateTransferTax">
                    <span>%</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">{{$store.getters.translations.notary_fees}}</div>
                  <div class="col-2 calc-value">
                    {{toLocalString(notary)}}
                    <span>€</span>
                  </div>
                  <div class="col-2 input-style">
                    <input v-bind:value="notaryFactor" class="percent-value"
                           @change="changeNotaryFactor" type="text" id="notary">
                    <span>%</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">{{$store.getters.translations.land_register_entry}}</div>
                  <div class="col-2 calc-value">
                    {{toLocalString(landRegister)}}
                    <span>€</span>
                  </div>
                  <div class="col-2 input-style">
                    <input v-bind:value="landRegisterFactor" class="percent-value"
                           @change="changeLandRegisterFactor" type="text" id="landRegister">
                    <span>%</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">{{$store.getters.translations.broker_commission}}</div>
                  <div class="col-2 calc-value">
                    {{toLocalString(brokerProvision)}}
                    <span>€</span>
                  </div>
                  <div class="col-2 input-style">
                    <input v-bind:value="brokerProvisionFactor" class="percent-value"
                           @change="changeBrokerProvisionFactor" type="text" id="brokerProvision">
                    <span>%</span>
                  </div>
                </div>
                <div class="row additional-costs-total">
                  <div class="col-8">{{$store.getters.translations.total_purchase_incidentals}}</div>
                  <div class="col-2 calc-value">{{toLocalString(additionalCosts)}} <span>€</span></div>
                  <div class="col-2"></div>
                </div>
              </div>

            <div class="col-12">
              <div class="row buttons">
                <div class="col-6">
                  <a class="button stop cta-button" @click.prevent="closeModal" href="" >{{$store.getters.translations.cancel}}</a>
                </div>
                <div class="col-6">
                  <a class="button use-value cta-button" @click.prevent="useCalculatedValue" href="" >{{$store.getters.translations.accept}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Caption text -->
      <div class="caption-container">
        <p id="caption"></p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ModalView",
  props:{
    showModal:{
      type:Boolean,
      default:false
    },
    sellingPrice:{
      type:Number,
      required:true
    }
  },
  data(){
    return {
      notaryFactor:"1,5",
      realEstateTransferTaxFactor:"5,0",
      landRegisterFactor:"0,5",
      brokerProvisionFactor:"4,76",
      additionalCostsFactor:0,
      notary:0,
      realEstateTransferTax:0,
      landRegister:0,
      brokerProvision:0,
      additionalCosts:0,
      trafficTaxes:[
        {
          value:'5,0',
          country:'Baden-Württemberg'
        },
        {
          value:'3,5',
          country:'Bayern'
        },
        {
          value:'6,0',
          country:'Berlin'
        },
        {
          value:'6,5',
          country:'Brandenburg'
        },
        {
          value:'5,0',
          country:'Bremen'
        },
        {
          value:'4,5',
          country:'Hamburg'
        },
        {
          value:'6,0',
          country:'Hessen'
        },
        {
          value:'6,0',
          country:'Mecklenburg-Vorpommern'
        },
        {
          value:'5,0',
          country:'Niedersachsen'
        },
        {
          value:'6,5',
          country:'Nordrhein-Westfalen'
        },
        {
          value:'5,0',
          country:'Rheinland-Pfalz'
        },
        {
          value:'6,5',
          country:'Saarland'
        },
        {
          value:'3,5',
          country:'Sachsen'
        },
        {
          value:'5,0',
          country:'Sachsen-Anhalt'
        },
        {
          value:'6,5',
          country:'Schleswig-Holstein'
        },
        {
          value:'6,5',
          country:'Thüringen'
        },
      ]
    }
  },
  emits:[
    'close-modal','additional-cost-calculated'
  ],
  watch:{
    sellingPrice(){
      this.calc();
      this.$emit('additional-cost-calculated-after-selling-price-change',this.additionalCosts);
    }
  },
  methods:{
    closeModal(){
      this.$emit('close-modal');
    },
    useCalculatedValue(){
      this.$emit('additional-cost-calculated',this.additionalCosts);
    },
    reformatStringToFloat(value){
      return parseFloat(String(value).replaceAll(',','.'));
    },
    reformatStringToInt(value){
      return parseInt(String(value).replaceAll('.',''));
    },
    toLocalString(value){
      return value.toLocaleString('de-DE');
    },
    changeNotaryFactor(event){
      this.notaryFactor = event.target.value;
      this.calc();
    },
    changeRealEstateTransferTaxFactor(event){
      this.realEstateTransferTaxFactor = event.target.value;
      this.calc();
    },
    changeLandRegisterFactor(event){
      this.landRegisterFactor = event.target.value;
      this.calc();
    },
    changeBrokerProvisionFactor(event){
      this.brokerProvisionFactor = event.target.value;
      this.calc();
    },
    changeRealEstateTransferTax(event){
      this.realEstateTransferTaxFactor = event.target.value;
      this.calc();
    },
    calc(){
      this.calcNotary();
      this.calcRealEstateTransferTax();
      this.calcLandRegister();
      this.calcBrokerProvision();
      this.calcAdditionalCostTotal();
    },

    calcNotary(){
      this.notary = this.calcCostValue(this.notaryFactor);
    },
    calcRealEstateTransferTax(){
      this.realEstateTransferTax = this.calcCostValue(this.realEstateTransferTaxFactor);
    },
    calcLandRegister(){
      this.landRegister = this.calcCostValue(this.landRegisterFactor);
    },
    calcBrokerProvision(){
      this.brokerProvision =  this.calcCostValue(this.brokerProvisionFactor);
    },

    calcCostValue(value){
      return (this.reformatStringToInt(this.sellingPrice)/100) * this.reformatStringToFloat(value);
    },

    calcAdditionalCostTotal(){
      this.additionalCosts =  this.notary;
      this.additionalCosts +=  this.realEstateTransferTax;
      this.additionalCosts +=  this.landRegister;
      this.additionalCosts +=  this.brokerProvision;
    }
  },
  mounted() {
    this.calc();
  }
}
</script>

<style scoped>
</style>
